// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutDiscoveryPage-cls1_ZvA","cls2":"LoggedOutDiscoveryPage-cls2_Y_h LoggedOutDiscoveryPage-cls1_ZvA"};